module.exports = __webpack_public_path__ + "static/media/search.633307b7.svg";